import React, {Component} from "react";
import Grid from '@material-ui/core/Grid';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Header from "./components/Header/Header"
//import Contact from "./components/Contact/Contact"
//import About from "./components/About/About"
import './App.css';
//import ChademoPage from "./components/ChademoPage/ChademoPage";
import Login from "./components/login/Login"
import LedText from "./components/ledtext/LedText"
import BusDB from "./components/busdb/BusDB"
import LedBMP from "./components/ledbmp/LedBMP"
import LedSend from "./components/ledsend/LedSend"
import Register from "./components/register/Register"
import AuthModal from "./components/Modals/AuthModal"
import { Autocomplete } from "@material-ui/lab";
import { useProject } from "./components/Providers"
import { LinkOff } from "@material-ui/icons";
//import axios from "axios"

const Application = () => {
  const { user, setUser} = useProject()

  const token = localStorage.getItem('accessToken');
  // if(token){
  //   setUser({
  //     id:1,
  //     role:'ADMIN',
  //     username:'ebase',
  //   })
  // }

  return (
    <div >
      <BrowserRouter>
      <Header/>
      {!user ? <Login/> :
      <Switch>
        <Route exact path="/ledtext">
          <LedText />
        </Route>
        <Route exact path="/ledbmp">
          <LedBMP />
        </Route>
        <Route exact path="/busdb">
          <BusDB />
        </Route>
        <Route exact path="/send">
          <LedSend />
        </Route>
        <Route exact path="/register">
          <Register />
        </Route>
        {/* <Route exact path="/about">
          <About />
        </Route> */}
        {/* <Route exact path="/chademo">
        {this.prepareComPortSelectButtons()}
          <Grid container justify='center'>
            <Grid item xs={12}>
              <div>
                {this.state.p1.selected === true ? <ChademoPage port={this.state.p1}/ > : null}
              </div>
            </Grid>
          </Grid>
        </Route>
         */}
      </Switch>}
      </BrowserRouter>
      {/* <AuthModal onClose={()=>null}/> */}
    </div>
  );
}

export default Application